// @ts-nocheck
import PropTypes from "prop-types";
import React, { useRef, useEffect, useState } from "react";
// import { usePullDownItemGroupRef } from "./PullDown";
import className from "./PullDownItemGroup.module.scss";
import { getImageUrl } from "../../../commons/assets_path";

/**
 * @arg {PropTypes.InferProps.<typeof PullDownItemGroup.propTypes>} props
 * @return {ReturnType.<React.FC>}
 */

function usePullDownItemGroupRef() {
  const ref = useRef();

  return ref;
}

export default function PullDownItemGroup({ children, title, image, iconType, isSearchCompleted, isSuggestClose }) {
  const [startAnimationFlag, setStartAnimationFlag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const ref = usePullDownItemGroupRef();
  const fileName = image?.split("/").pop();

  const onClickIcon = () => {
    setStartAnimationFlag(true);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isSearchCompleted) {
      setStartAnimationFlag(true);
      ref.current.open = true;
      setIsOpen(true);
    } else {
      ref.current.open = false;
      setIsOpen(false);
    }
  }, [isSearchCompleted]);

  useEffect(() => {
    setStartAnimationFlag(false);
    setIsOpen(false);
    ref.current.open = false;
  }, [isSuggestClose]);

  useEffect(() => {
    if (isSearchCompleted) {
      setStartAnimationFlag(true);
      ref.current.open = true;
      setIsOpen(true);
    } else {
      ref.current.open = false;
      setIsOpen(false);
    }
  }, [isSearchCompleted]);

  useEffect(() => {
    setStartAnimationFlag(false);
    setIsOpen(false);
    ref.current.open = false;
  }, [isSuggestClose]);

  return (
    <details className={className.details} ref={ref}>
      <summary className={className.summary} style={{ zIndex: "100" }} onClick={() => onClickIcon()}>
        {image && <img src={iconType === "service" ? image : getImageUrl(image)} className={className.icon} />}
        <span>
          <span>{title}</span>
          <img
            src={getImageUrl("images/icons/chevron-right.svg")}
            width={24}
            height={24}
            style={{ marginLeft: "7px" }}
            className={startAnimationFlag ? (isOpen ? className.rotateAnime : className.reverseRotateAnime) : ""}
          />
        </span>
      </summary>
      <div className={className.content}>{children}</div>
    </details>
  );
}

PullDownItemGroup.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  image: PropTypes.node,
  iconType: PropTypes.string,
  isSearchCompleted: PropTypes.bool,
  isSuggestClose: PropTypes.bool,
};
